import React from 'react';
import styled from 'styled-components';
import { layout, colors } from 'Constants';

const Hero = styled.div`
background-image: url(${props => props.image});
background-size:auto;
background-repeat:no-repeat ;
background-position-x:100%;
width: 100%;
height: 450px;
display: flex;
align-items: center;
justify-content: center;
`;

const HeroInner = styled.div`
  max-width: ${layout.maxWidth};
  display: flex;
  width: 100%;
  justify-content:center ;

  @media screen and (max-width: ${layout.breakpoints.mobile}) {
    width: auto;
  }
`;


const WrapperDiv=styled.div`
flex:1;
min-width:400px ;
@media screen and (max-width: ${layout.breakpoints.mobile}) {
    width: 100%;
  }
`;


const MainWrap=styled.div`


display:flex ;
align-items:center ;
flex-wrap:wrap-reverse ;
margin: auto;
@media screen and (max-width: ${layout.breakpoints.mobile}) {
  margin:0px;
  }



`;

const HeroImage=styled.img`
min-width:420px;
 @media(max-width:${layout.breakpoints.mobile}) {
 min-width:auto ;
 width:100vw ;
 }
`;

const HeroImageHolder=styled.div`
min-width:420px;
flex:1;
 @media(max-width:${layout.breakpoints.mobile}) {
 min-width:auto ;
 width:100vw ;
 }
`;

export default class NavBar extends React.Component {
  render() {
    return (
      <MainWrap  >
        <WrapperDiv>
          <HeroInner>{this.props.children}</HeroInner>
        </WrapperDiv>
        <HeroImageHolder  >
          <HeroImage src={this.props.image}/>
        </HeroImageHolder>
      </MainWrap>
    );
  }
}
